import React from "react";
import OrderlistWrapper from "./OrderList.style";
import { Radio } from "antd";
import PartialOrderTooltip from "./PartialOrderTooltip";

const OrdersSelectList = (props) => {
  const { orders, activeEvent, onChange } = props;

  const OrderListItem = ({ order }) => {
    return (
      <Radio value={order.id}>
        {order["client"].name}
        <PartialOrderTooltip order={order} />
      </Radio>
    );
  };

  const renderOrders = () => {
    if (!orders) {
      return null;
    }

    const filtered = orders.filter(
      (j) =>
        !j?.order_service_type?.supporting_community &&
        !j?.order_service_type?.day_center
    );

    return filtered.map((order, i) => (
      <OrderListItem order={order} key={order.id} />
    ));
  };
  return (
    <OrderlistWrapper>
      <Radio.Group
        onChange={onChange}
        value={
          activeEvent && activeEvent["order"] ? activeEvent["order"].id : ""
        }
      >
        {renderOrders()}
      </Radio.Group>
    </OrderlistWrapper>
  );
};

export default OrdersSelectList;
